import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './App.css';
import Map from './map';
import GalleryButton from './galleryButton'; 


function CentroConTabla(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='location'>
      <div className='location-container'>
        <div className='table'>
          <div className="table-content">
            <div className="table-left">
              <h1 className='title-location'>{props.titulo}</h1>
              <p className='address'>{props.texto}</p>
              <p className='address2'>{props.texto2}</p>
              <h4 className='titleLocation'>{props.titulo2}</h4>
              <table className='table-Opendata'>
                <tbody>
                  {props.tablaData.map((fila, index) => (
                    <tr className='tbody' key={index}>
                      <td>{fila.columna1}</td>
                      <td>{fila.columna2}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              
            </div>
            <div className="table-right">
              {props.mapK}
              <GalleryButton images={props.images} modalTitle={props.modalTitle} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const Compo1 = {
  titulo: "Ormiston Town Centre",
  imagenUrl: "img/stores.png",
  texto: 'Kranestation is located in 240 Ormiston Road, Flat Bush, Auckland 2016',
  texto2: 'Located in the Ormiston Town Centre Food Court by the HOYTS escalators.',
  titulo2: "Opening Hours:",
  tablaData: [
    { columna1: "Monday", columna2: "10:00am - 22:00pm" },
    { columna1: "Tuesday", columna2: "10:00am - 22:00pm" },
    { columna1: "Wednesday", columna2: "10:00am - 22:00pm" },
    { columna1: "Thursday", columna2: "10:00am - 22:00pm" },
    { columna1: "Friday", columna2: "10:00am - 22:00pm" },
    { columna1: "Saturday", columna2: "10:00am - 22:00pm" },
    { columna1: "Sunday", columna2: "10:00am - 22:00pm" },
  ],
  mapK: <Map coordinates={[-36.9661577, 174.9126717]} />,
  images: [
    { src: "/img/Ormiston/img1.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img2.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img3.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img4.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img5.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img6.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img7.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img8.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img9.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img10.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img11.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img12.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img13.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img14.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img15.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img16.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img17.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img18.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img19.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img20.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img21.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img22.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img23.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img24.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img25.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img26.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img27.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img28.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img29.jpg", alt: "play toy crane" },
    { src: "/img/Ormiston/img30.jpg", alt: "play toy crane" },
    
  ],
    modalTitle: "Ormiston Town Centre Gallery"
};

const Compo2 = {
  titulo: "Sylvia Park - HOYTS Cinemas",
  imagenUrl: "img/stores.png",
  texto: "Kranestation is located in Sylvia Park Shopping Centre, 286 Mount Wellington Highway, 1060",
  titulo2: "Opening Hours:",
  tablaData: [
    { columna1: "Monday", columna2: "09:45am - 11:30pm" },
    { columna1: "Tuesday", columna2: "09:45am - 11:30pm" },
    { columna1: "Wednesday", columna2: "09:45am - 11:30pm" },
    { columna1: "Thursday", columna2: "09:45am - 11:30pm" },
    { columna1: "Friday", columna2: "09:45am - 11:30pm" },
    { columna1: "Saturday", columna2: "09:45am - 11:30pm" },
    { columna1: "Sunday", columna2: "09:45am - 11:30pm" },
  ],
  mapK: <Map coordinates={[-36.9148183, 174.8417822]} />, 
  images: [
    { src: "/img/Hoyts/img1.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img2.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img3.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img4.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img5.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img6.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img7.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img8.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img9.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img10.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img11.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img12.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img13.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img14.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img15.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img16.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img17.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img18.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img19.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img20.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img21.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img22.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img23.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img24.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img25.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img26.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img27.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img28.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img29.jpg", alt: "play toy crane" },
    { src: "/img/Hoyts/img30.jpg", alt: "play toy crane" },    
  ],
   modalTitle: "Sylvia Park HOYTS Cinemas Gallery"
};

const Compo3 = {
  titulo: "Lynn Mall",
  imagenUrl: "img/stores.png",
  texto: "3058 Great North Road, New Lynn, Auckland 0640",
  titulo2: "Opening Hours:",
  tablaData: [
    { columna1: "Monday", columna2: "9:00am - 21:00pm" },
    { columna1: "Tuesday", columna2: "9:00am - 21:00pm" },
    { columna1: "Wednesday", columna2: "9:00am - 21:00pm" },
    { columna1: "Thursday", columna2: "9:00am - 21:00pm" },
    { columna1: "Friday", columna2: "9:00am - 21:00pm" },
    { columna1: "Saturday", columna2: "9:00am - 21:00pm" },
    { columna1: "Sunday", columna2: "9:00am - 21:00pm" },
  ],
  mapK: <Map coordinates={[-36.9076227, 174.6859924]} />,
  images: [
    { src: "/img/lynnMall/img01.jpg", alt: "play toy crane" },
    { src: "/img/lynnMall/img02.jpg", alt: "play toy crane" },
    { src: "/img/lynnMall/img03.jpg", alt: "play toy crane" },
    { src: "/img/lynnMall/img04.jpg", alt: "play toy crane" },
    { src: "/img/lynnMall/img05.jpg", alt: "play toy crane" },
    { src: "/img/lynnMall/img06.jpg", alt: "play toy crane" },
    { src: "/img/lynnMall/img07.jpg", alt: "play toy crane" },
    { src: "/img/lynnMall/img08.jpg", alt: "play toy crane" },
    { src: "/img/lynnMall/img09.jpg", alt: "play toy crane" },
    { src: "/img/lynnMall/img10.jpg", alt: "play toy crane" },

  ],
    modalTitle: "LynnMall Shopping Centre"
};

// lo nuevo

const Compo4 = {
  titulo: "Dress Smart",
  imagenUrl: "img/stores.png",
  texto: "51 Arthur Street, Onehunga, Auckland 0632",
  titulo2: "Opening Hours:",
  tablaData: [
    { columna1: "Monday", columna2: "10:00am - 18:00pm" },
    { columna1: "Tuesday", columna2: "10:00am - 18:00pm" },
    { columna1: "Wednesday", columna2: "10:00am - 18:00pm" },
    { columna1: "Thursday", columna2: "10:00am - 18:00pm" },
    { columna1: "Friday", columna2: "10:00am - 18:00pm" },
    { columna1: "Saturday", columna2: "9:00am - 18:00pm" },
    { columna1: "Sunday", columna2: "9:00am - 18:00pm" },
    // Other days...
  ],
  mapK: <Map coordinates={[-36.9217166, 174.7866633]} />,
  images: [
    { src: "/img/DressSmart/img01.jpg", alt: "claw machine" },
    { src: "/img/DressSmart/img02.jpg", alt: "claw machine" },
    { src: "/img/DressSmart/img03.jpg", alt: "claw machine" },
    { src: "/img/DressSmart/img04.jpg", alt: "claw machine" },
    { src: "/img/DressSmart/img05.jpg", alt: "claw machine" },
    { src: "/img/DressSmart/img06.jpg", alt: "claw machine" },
    { src: "/img/DressSmart/img07.jpg", alt: "claw machine" },

  ],
  modalTitle: "Dress Smart Outlet Shopping Centre"
};

const Compo5 = {
  titulo: "Shore City",
  imagenUrl: "img/stores.png",
  texto: "52/56 Anzac Street, Takapuna, Auckland 0622",
  titulo2: "Opening Hours:",
  tablaData: [
    { columna1: "Monday", columna2: "9:00am - 18:00pm" },
    { columna1: "Tuesday", columna2: "9:00am - 18:00pm" },
    { columna1: "Wednesday", columna2: "9:00am - 18:00pm" },
    { columna1: "Thursday", columna2: "9:00am - 21:00pm" },
    { columna1: "Friday", columna2: "9:00am - 18:00pm" },
    { columna1: "Saturday", columna2: "9:00am - 18:00pm" },
    { columna1: "Sunday", columna2: "9:00am - 17:00pm" },
    // Other days...
  ],
  mapK: <Map coordinates={[-36.787808, 174.7699617]} />,
  images: [
    { src: "/img/ShoreCity/img01.jpg", alt: "claw machine" },
    { src: "/img/ShoreCity/img02.jpg", alt: "claw machine" },
 
  ],
  modalTitle: "Shore City Shopping Centre"
};

const Compo6 = {
  titulo: "Aotea Square",
  imagenUrl: "img/stores.png",
  texto: "Aotea Square, Auckland City 1010",
  titulo2: "Opening Hours:",
  tablaData: [
    { columna1: "Monday", columna2: "7:00am - 10:00pm" },
    { columna1: "Tuesday", columna2: "7:00am - 10:00pm" },
    { columna1: "Wednesday", columna2: "7:00am - 10:00pm" },
    // Other days...
  ],
  mapK: <Map coordinates={[-36.849435, 174.7699988]} />,
  images: [
    { src: "/img/AoteaSquare/img1.jpg", alt: "claw machine" },
    { src: "/img/AoteaSquare/img2.jpg", alt: "claw machine" },
    { src: "/img/AoteaSquare/img3.jpg", alt: "claw machine" },
    { src: "/img/AoteaSquare/img4.jpg", alt: "claw machine" },
    { src: "/img/AoteaSquare/img1.jpg", alt: "claw machine" },
    { src: "/img/AoteaSquare/img1.jpg", alt: "claw machine" },
    { src: "/img/AoteaSquare/img1.jpg", alt: "claw machine" },

    // Other images...
  ],
  modalTitle: "Aotea Square Gallery"
};

function TableComponent() {
  const { id } = useParams();

  const components = {
    '1': Compo1,
    '2': Compo2,
    '3': Compo3,
    '4': Compo4,
    '5': Compo5,
    '6': Compo6
  };

  const selectedComponent = components[id] || Compo1;

  return (
    <div className='table-component'>
      <CentroConTabla {...selectedComponent} />
    </div>
  );
}

export default TableComponent;



